import { Flex, Alert, AlertIcon, AlertTitle, AlertDescription } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { UserSection } from "./UsersSection";
import { useUsers } from "../../../apiQueries";

export const UsersPanel: FunctionComponent = () => {
    const { data: users = [], isLoading, error, isError } = useUsers();

    if (isError) {
        return (
            <Flex flexFlow="column nowrap">
                <Alert status="error">
                    <AlertIcon />
                    <AlertTitle>Failed to load users</AlertTitle>
                    <AlertDescription>
                        {error instanceof Error ? error.message : "An error occurred while fetching users. Please check if you have the required permissions."}
                    </AlertDescription>
                </Alert>
            </Flex>
        );
    }

    return (
        <>
            <Flex flexFlow="column nowrap">
                <UserSection users={users} isLoading={isLoading} />
            </Flex>
        </>
    );
};
